import { MODAL_ALERTA_HIDE, MODAL_ALERTA_SHOW } from "../../ActionTypes";

export const showModalAlerta =
  (type, text, accion, bloquearDismiss) => (dispatch) => {
    dispatch({
      type: MODAL_ALERTA_SHOW,
      payload: {
        type: type,
        text: text,
        accion: accion,
        bloquearDismiss: bloquearDismiss,
      },
    });
  };

export const hideModalAlerta = () => (dispatch) => {
  dispatch({
    type: MODAL_ALERTA_HIDE,
  });
};
